import Image from 'next/image';

import { css, styled } from '@lichtblick/styled';
import { BorderRadius, Colors, Spacing } from '@lichtblick/theme';

import { IconButton } from '../IconButton';

export const RootContainer = styled.div<{ $ratio: number; $width?: number }>`
  position: relative;
  ${({ $ratio, $width }) => {
    if (!$width) {
      return;
    }

    return $ratio > 1
      ? css`
          min-height: ${$width / $ratio};
          min-width: ${$width}px;
        `
      : css`
          min-height: ${$width}px;
          min-width: ${$width * $ratio}px;
        `;
  }}
`;

export const ImageContainer = styled(Image)`
  border-radius: ${BorderRadius.S};
  display: block;
  overflow: hidden;
`;

export const DialogTrigger = styled(IconButton)`
  bottom: ${Spacing.Xxs};
  position: absolute;
  right: ${Spacing.Xxs};
  > svg {
    color: ${Colors.blue[100]};
  }
`;

export const DialogContent = styled.div`
  height: 60vh;
  margin: ${Spacing.M};
`;

export const Counter = styled.div`
  align-items: center;
  background-color: ${Colors.white};
  border-radius: ${BorderRadius.Full};
  display: flex;
  height: 2rem;
  justify-content: center;
  position: absolute;
  right: ${Spacing.Xxs};
  top: ${Spacing.Xxs};
  width: 2rem;
`;
